<template>
  <div class="rule-overview" :class="isTemplate ? 'w-100' : ''">
    <div class="rule-overview-header">{{ $t('meter.suggestion_rule') }}</div>
    <div class="rule-overview-title mt-3">
      {{ $t('scope.text_19') }}<span class="rule-overview-title-number" @click="handleClick">{{ all }}</span>{{$t('bill.suggest_unit')}}
    </div>
    <div class="rule-overview-content">
      <e-chart id="rule-overview-chart" domId="rule-overview-chart" :options="chartOptions" chart-style="width:100%;height:100%" autoresize />
    </div>
  </div>
</template>

<script>
import { chartColors } from '@/constants'

export default {
  name: 'RuleOverview',
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    isTemplate: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    all () {
      return Object.values(this.data).reduce((acc, curr) => acc + curr, 0)
    },
    series () {
      const ret = {}
      Object.keys(this.data).forEach(type => {
        if (type.includes('UP_DOWN_')) {
          ret.up_down = (ret.up_down || 0) + this.data[type]
        } else if (type === 'UPGRADE_PREPAID') {
          ret.upgrade_prepaid = (ret.upgrade_prepaid || 0) + this.data[type]
        } else if (type.includes('UNUSED_')) {
          ret.unused = (ret.unused || 0) + this.data[type]
        }
      })
      return Object.keys(ret).map(key => {
        return {
          name: this.$t(`bill.suggest_rule_type.${key}`),
          value: ret[key],
        }
      })
    },
    chartOptions () {
      return {
        legend: {
          show: true,
          width: '95%',
          type: 'scroll',
          bottom: 0,
          tooltip: {
            show: true,
            formatter: (params) => {
              if (params.name === this.$t('bill.suggest_rule_type.up_down')) {
                return this.$t('bill.suggest_rule_type.up_down_tip')
              } else if (params.name === this.$t('bill.suggest_rule_type.upgrade_prepaid')) {
                return this.$t('bill.suggest_rule_type.upgrade_prepaid_tip')
              } else if (params.name === this.$t('bill.suggest_rule_type.unused')) {
                return this.$t('bill.suggest_rule_type.unused_tip')
              }
              return params.name
            },
          },
        },
        color: chartColors,
        tooltip: {
          trigger: 'item',
          position: (point, params, dom, rect, size) => {
            dom.style.border = 'none'
            dom.style.backgroundColor = '#fff'
            dom.style.color = '#5D6F80'
            dom.style.border = '1px solid #C8E2F7'
          },
        },
        series: [
          {
            type: 'pie',
            radius: '50%',
            label: {
              show: false,
            },
            data: this.series,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)',
              },
            },
            tooltip: {
              trigger: 'item',
            },
          },
        ],
      }
    },
  },
  methods: {
    handleClick () {
      this.$router.push({
        path: '/suggestsysrule',
        query: {
          enabled: true,
        },
      })
    },
  },
}
</script>

<style lang="less" scoped>
.rule-overview {
  border: 1px solid #e8e8e8;
  padding: 12px;
  border-radius: 3px;
  width: 33%;
  flex: 0 0 33%;
  .rule-overview-title {
    text-align: center;
    .rule-overview-title-number {
      display: inline-block;
      font-size: 2.5em;
      margin-left: 10px;
      margin-right: 10px;
      color: var(--antd-wave-shadow-color);
      &:hover {
        cursor: pointer;
      }
    }
  }
  .rule-overview-content {
    height: 80%;
  }
}
</style>
